import { RetellWebClient } from "retell-client-js-sdk";
window.Retell = new RetellWebClient();
